class FaqEntity extends Component {
	constructor(el) {
		super(el);
		this.question = this.$find('[data-question]');
		this.openedClass = 'is-opened';
		this.addEventListeners();
	}

	toggleAnswer(current) {
		if(current === this && !current.$el.classList.contains(this.openedClass)) {
			this.$el.classList.add(this.openedClass);
			return;
		}
		this.$el.classList.remove(this.openedClass);
	}

	addEventListeners() {
		this.question.addEventListener('click', () => {
			EventBus.getInstance().dispatchEvent('faqItemOpened', this);
		});
		EventBus.getInstance().addEventListener('faqItemOpened', e => this.toggleAnswer(e.detail));
	}
}